import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { Trip } from '../../DataStructures/Trip/Trip';

@Component({
  selector: 'app-share-link-dialog',
  templateUrl: './share-link-dialog.component.html',
  styleUrls: ['./share-link-dialog.component.css']
})
export class ShareLinkDialogComponent implements OnInit {

  trip:Trip
  copied = false;
  email;
  allowLocation = false;
  sharePhone = false;
  link:"The link is loading....";
  constructor(public dialogRef: MatDialogRef<ShareLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private main: MainService) {
        this.trip = data;
        this.email = this.trip.metadata.email;
    }

  ngOnInit() {
    this.loadLink();
  }

  loadLink(){
    this.link = "The link is loading....";
    this.main.getTrackingLink(this.trip.id,this.allowLocation,this.sharePhone).then((res) =>{
      console.log(res);
      this.link = res.data;
    })
  }
  
  copyToClipboard(text: string) {
    var nav : any = navigator;
    nav.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() =>{
        this.copied = false;
      },2000);
      console.log('Link Copied');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  onAllowLocation(event){
    this.loadLink();
  }

  onSharePhone(event){
    this.loadLink();
  }

  shareEmail(){
    this.main.emailTrackingLink(this.email,this.link).then((res) =>{
    
      this.dialogRef.close(true);
    }).catch(e =>{
      this.dialogRef.close(false);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/share-link-dialog/share-link-dialog.component.ts